import React, { Component } from 'react';
import PropTypes from 'prop-types';

import QuestionCircle from '@deliveroo/icon-set/react/QuestionCircle';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import i18n from '../../utils/i18n';
import OrderDetailsColumnContainer from '../../containers/OrderDetailsColumn';
import styles from './styles.scss';

class OrderStatusErrorPage extends Component {
  constructor(props) {
    super(props);

    this.onTryAgain = this.onTryAgain.bind(this);
  }

  onTryAgain() {
    if (window && typeof window !== 'undefined') {
      window.location.reload(true);
    }
  }

  render() {
    const { orderId } = this.props;

    return (
      <div className={styles.content}>
        <div className={styles.primary}>
          <div className={styles['order-help-link-container']}>
            <a
              className={styles['order-help-link']}
              href={`/orders/${orderId}/help?redirectTo=/orders/${orderId}/status`}
            >
              <span className={styles['order-help-link-icon']}>
                <Icon component={QuestionCircle} size={18} />
              </span>

              {i18n.gettext('order_status_page.order_help')}
            </a>
          </div>

          <div className={styles['primary-content']}>
            <Heading level={4} spacing="0 0 small">
              {i18n.gettext('order_status_post_checkout_tracking_failed_to_load_title')}
            </Heading>
            <P color="grey" spacing="0 0 large">
              {i18n.gettext('order_status_post_checkout_tracking_failed_to_load_message')}
            </P>

            <div className={styles['button-row']}>
              <div className={styles['try-again']}>
                <Button isBlock onClick={this.onTryAgain} type="primary">
                  {i18n.gettext('order_status_post_checkout_loading_button')}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.secondary}>
          <OrderDetailsColumnContainer isPolling={false} />
        </div>
      </div>
    );
  }
}

OrderStatusErrorPage.propTypes = {
  orderId: PropTypes.string.isRequired,
};

export default OrderStatusErrorPage;
